import React from 'react';
import { Typography } from '@mui/material';

const NotFound = () => (
  <div>
    <Typography variant="h4" color="error">
      404 - Pagina non trovata
    </Typography>
  </div>
);

export default NotFound;
